import { Injectable } from '@angular/core';
import { Observable, Subscription, timer } from 'rxjs';
import { NetworkService } from 'src/app/network/network.service';
import { DriverTemplate } from '../driver-template';
import { TimerHandle } from 'rxjs/internal/scheduler/timerHandle';

export interface PeyeCoordinates {
  x: any;
  y: any;
}
@Injectable({
  providedIn: 'root',
})
export class EyeTrackerService extends DriverTemplate {
  enabled = false;

  x = 0;
  y = 0;

  private coordEye: PeyeCoordinates = { x: 0, y: 0 };

  protected eyesPositionHttpRequest: Observable<string>;

  protected eyeTrackerTimer: Observable<number>;
  protected eyeTrackerTimerSubscription: Subscription;

  private eyePositionRequestDone = true;

  isSleeping = true;

  constructor(private networkService: NetworkService) {
    super();
  }

  start(): Promise<boolean> {
    this.myStatus.enabled = true;
    if (this.myStatus.running === true) {
      return Promise.resolve(false);
    } else {
      if (this.enabled === false) {
        console.log('eye-tracker start');

        this.eyeTrackerTimer = timer(0, 100);

        this.eyeTrackerTimerSubscription = this.eyeTrackerTimer.subscribe(
          (t) => {
            console.log(
              'requestEyesPosition',
              this.eyeTrackerTimerSubscription
            );
            this.requestEyesPosition();
          }
        );

        this.myStatus.running = true;

        this.enabled = true;
        this.isSleeping = false;

        return Promise.resolve(true);
      }
    }
  }

  stop(): Promise<boolean> {
    if (this.enabled) {
      console.log('eye-tracker stop');

      //console.log('eye-tracker unsubscribe', this.eyeTrackerTimerSubscription);
      this.eyeTrackerTimerSubscription.unsubscribe();
      this.myStatus.running = false;
      this.myStatus.enabled = false;
    }

    this.enabled = false;

    return Promise.resolve(true);
  }

  public isEnabled() {
    return this.enabled;
  }

  sleep() {
    this.isSleeping = true;
  }

  awake() {
    this.isSleeping = false;
  }

  private requestEyesPosition() {
    if (this.eyePositionRequestDone) {
      this.eyePositionRequestDone = false;
      this.eyesPositionHttpRequest =
        this.networkService.tobiiEyeTrackerHttpEyePosition();
      this.networkService.tobiiEyeTrackerHttpEyePosition().subscribe(
        (data) => this.eyesPositionHttpResponseHandle(data),
        (err) => this.eyesPositionHttpErrorHandle()
      );
    }
  }

  private eyesPositionHttpResponseHandle(data) {
    //console.log(data);

    var eyePosition = data.split(' ');
    var eyePositionX = parseInt(eyePosition[0], 10);
    var eyePositionY = parseInt(eyePosition[1], 10);

    //var eyePositionX = data.value.split(" ")[0];
    //var eyePositionY = data.value.split(" ")[1];

    console.log('eye-tracker eyePositionX: ' + eyePositionX);
    console.log('eye-tracker eyePositionY: ' + eyePositionY);
    // Calculates the Browser's header height
    // const x = (eyePositionX - window.scrollX) / window.innerWidth;
    // const y = (eyePositionY + window.scrollY - window.outerHeight + window.innerHeight) / window.innerHeight;
    const x = (eyePositionX - window.screenX) / window.innerWidth;
    const y =
      (eyePositionY -
        window.screenY -
        window.outerHeight +
        window.innerHeight) /
      window.innerHeight;

    this.eyePositionRequestDone = true;
    this.coordEye = { x: x, y: y };

    //EventEmitterService.get('eye-tracker-event').emit({event: 'EYE_TRACKER_COORD', x: eyePositionX, y: eyePositionY});

    this.captureResultCallback({
      captureTime: performance.now(),
      coordinates: this.coordEye,
    });
  }

  private eyesPositionHttpErrorHandle() {
    console.log('Error in requestEyesPosition');
    this.eyePositionRequestDone = true;
  }
}
